/*
 * @Description: 在线考试路由
 * @Author: ywl
 * @Date: 2021-03-31 10:44:33
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-27 17:10:01
 */
import { RouteConfig } from 'vue-router';
import Layout from '@/layouts/layout.vue';

const onlineRoute: RouteConfig[] = [
  {
    path: '/online',
    component: Layout,
    redirect: '/online/list.html',
    children: [
      {
        path: 'list.html',
        name: 'onlineList',
        component: () => import('@/views/questionnaire/list.vue'),
        meta: { title: '在线测试', parentTab: 'onlineTest' },
      },
    ],
  },
];

export { onlineRoute };
